import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-access-denied',
    styleUrls: ['./access-denied.component.scss'],
    templateUrl: './access-denied.component.html',
    standalone: false
})
export class AccessDeniedComponent {}
